import { rawTimeZones } from '@vvo/tzdb'
import { orderBy } from 'lodash'

export const getTimezones = () => {
  // sort the timezones by offset and then by name
  return orderBy(rawTimeZones, ['rawOffsetInMinutes', 'name'])

  // TODO: only show the groups?
}

// export const getAbbreviatedTimezones = () => {
//   const foundAbbreviations = []
//   const abbreviatedTimezones = []
//   rawTimeZones.forEach((timezone) => {
//     if (foundAbbreviations.indexOf(timezone.abbreviation) === -1) {
//       var m = Math.abs(timezone.rawOffsetInMinutes % 60)
//       var h = (timezone.rawOffsetInMinutes - m) / 60
//       var HHMM = h.toString() + ':' + (m < 10 ? '0' : '') + m.toString()

//       foundAbbreviations.push(timezone.abbreviation)
//       abbreviatedTimezones.push({
//         value: timezone.abbreviation,
//         offset: timezone.rawOffsetInMinutes,
//         prettyOffset: HHMM,
//         group: timezone.group,
//         label: timezone.abbreviation + ' (' + HHMM + ')'
//       })
//     } else {
//       // update the group
//       const record = abbreviatedTimezones[foundAbbreviations.indexOf(timezone.abbreviation)]

//       // add group items if they dont exist
//       timezone.group.forEach((newGroup) => {
//         if (record.group.indexOf(newGroup) === -1) record.group.push(newGroup)
//       })
//     }
//   })

//   return abbreviatedTimezones
// }

export function getTimezoneRecord(timezone, timezones) {
  return timezones.filter((t) => {
    // if (t.group.indexOf(timezone) !== -1) {
    //   selectedTimezone = {
    //     value: t.value,
    //     label: t.label
    //   }
    // }
    return t.name === timezone
  })[0]
  // return selectedTimezone
}

export const getLocalTime = (datetime, timezone) => {
  // if datetime is a firebase date object convert it to a javascript date object
  if (datetime?.toDate) datetime = datetime.toDate()
  const ampmCountries = 'US,CA,UK,IE,GB,AU,NZ'.split(',')
  const date = new Date(datetime)
  const options = {
    hour: '2-digit',
    minute: '2-digit',
  }

  if (timezone && timezone != 'Etc/Unknown') {
    options.timeZone = timezone

    // get the country
    const countryCode = rawTimeZones.filter(({ name }) => name === timezone)
    if (countryCode.length === 1) {
      if (ampmCountries.indexOf(countryCode[0].countryCode) !== -1) {
        // options.hour12 = true
        options.hour = 'numeric'
        options.hourCycle = 'h12'
      }
    }
  }

  return date.toLocaleTimeString('en-GB', options)
}

export const getLocalDay = (datetime, timezone) => {
  const date = new Date(datetime)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  if (timezone && timezone != 'Etc/Unknown') options.timeZone = timezone
  else options.timeZone = 'UTC'
  return date.toLocaleString('en-US', options) // need for date filters
}

export const getSessionDateTime = (datetime, timezone) => {
  const date = new Date(datetime)
  const options = {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }
  if (timezone && timezone != 'Etc/Unknown') options.timeZone = timezone
  return date.toLocaleString('en-fr', options)
}

export const getPrettyDay = (datetime, timezone) => {
  // if datetime is a firebase date object convert it to a javascript date object
  if (datetime?.toDate) datetime = datetime.toDate()
  const date = new Date(datetime)
  const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }
  if (timezone && timezone != 'Etc/Unknown') options.timeZone = timezone
  return date.toLocaleString('en-GB', options)
}
